import { useTranslation } from 'react-i18next'

import { EMPTY_OBJECT } from '../../../constants/common'
import { formatNumberWithSeparators } from '../../../utils/number'
import Text from '../../Text'
import { useEpostFormContext } from '../Epost.hooks'

import * as styles from './EpostFormCalculatedTable.module.css'

function EpostFormCalculatedTable() {
  const { t } = useTranslation()

  const { calculatingData } = useEpostFormContext()

  const { isEnoughCredits, total, ukCredits, ukCreditsAfter } =
    calculatingData || EMPTY_OBJECT

  const notEnoughCreditsTextProps = isEnoughCredits
    ? null
    : {
        className: styles.notEnoughCredits,
      }

  return (
    <div className={styles.EpostFormCalculatedTable}>
      <div className={styles.EpostFormCalculatedTableHeader}>
        <Text className={styles.headerText}>
          {t('Epost.TotalCostTitleKey')}
        </Text>
        <Text className={styles.headerText}>
          {formatNumberWithSeparators(total)}
        </Text>
      </div>
      <div className={styles.EpostFormCalculatedTableRow}>
        <Text {...notEnoughCreditsTextProps}>
          {t('Epost.UkCreditsNowTitleKey')}
        </Text>
        <Text {...notEnoughCreditsTextProps}>
          {formatNumberWithSeparators(ukCredits)}
        </Text>
      </div>
      <div className={styles.EpostFormCalculatedTableRow}>
        <Text>
          {isEnoughCredits
            ? t('Epost.UkCreditsAfterTitleKey')
            : t('Epost.UkNotEnoughCreditsTitleKey')}
        </Text>
        <Text>
          {formatNumberWithSeparators(
            isEnoughCredits ? ukCreditsAfter : ukCreditsAfter * -1
          )}
        </Text>
      </div>
    </div>
  )
}

export default EpostFormCalculatedTable
